import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
interface Purchase {
  name: string;
  country: string;
  minutes: number;
}
export function SalesPopup() {
  const [purchase, setPurchase] = useState<Purchase | null>(null);
  useEffect(() => {
    let index = Math.floor(Math.random() * recentBuyers.length);
    let hideTimer: number;
    let showTimer: number;
    const cycle = () => {
      const buyer = recentBuyers[index % recentBuyers.length];
      index += 1;
      setPurchase({
        name: buyer.name,
        country: buyer.country,
        minutes: 1 + Math.floor(Math.random() * 9)
      });
      hideTimer = window.setTimeout(() => setPurchase(null), 6000);
      showTimer = window.setTimeout(cycle, 15000);
    };
    const firstTimer = window.setTimeout(cycle, 8000);
    return () => {
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
      window.clearTimeout(showTimer);
    };
  }, []);
  return <div className={`fixed left-3 top-3 z-50 w-[min(20rem,calc(100vw-1.5rem))] transition-[opacity,transform] duration-200 ease-out ${purchase ? 'translate-y-0 opacity-100' : 'pointer-events-none -translate-y-2 opacity-0'}`} role="status" aria-live="polite" data-id="element-216" data-mp="1zsnyqchl45yv">
      {purchase && <div className="flex items-start gap-3 rounded-xl border border-ink-600 bg-ink-800/95 p-3 shadow-2xl backdrop-blur" data-id="element-217" data-mp="2ehtrbhlx2xxs">
          <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-good" aria-hidden="true" data-id="element-218" data-mp="2ikgrc5sqrp62" />
          <div className="min-w-0 flex-1" data-id="element-219" data-mp="2nj0e28f5t4zh">
            <p className="text-sm font-semibold leading-snug text-white" data-id="element-220" data-mp="2shblydlw95f2">
              {purchase.name} aus {purchase.country}
            </p>
            <p className="mt-0.5 text-xs leading-snug text-white/60" data-id="element-221" data-mp="2xdaf0ei63blt">
              hat gerade das MEISTER-SCHWEISSSYSTEM™ gekauft · vor {purchase.minutes} Min.
            </p>
          </div>
          <button type="button" onClick={() => setPurchase(null)} aria-label="Hinweis schließen" className="rounded-md p-1 text-white/40 transition-colors duration-150 ease-out hover:text-white" data-id="element-222" data-mp="131lxq5ogqwy9">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-223" data-mp="14z3sk9evid1q" />
          </button>
        </div>}
    </div>;
}